import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Calculator from "@/pages/Calculator";
import Snapshot from "@/pages/Snapshot";
import FirstTimeBuyer from "@/pages/FirstTimeBuyer";
import Remortgage from "@/pages/Remortgage";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import SurveyQuote from "@/pages/SurveyQuote";
import RewardTerms from "@/pages/RewardTerms";
import Rewards from "@/pages/Rewards";
import ConveyancingQuote from "@/pages/ConveyancingQuote";
import StampDuty from "@/pages/StampDuty";
import About from "@/pages/About";
import EditorialStandards from "@/pages/EditorialStandards";
import Cashback, { CashbackUnavailable } from "@/pages/Cashback";
import { cashbackPromotionEnabled } from "@/config/promotions";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/snapshot" element={<Snapshot />} />
            <Route path="/first-time-buyer-guide" element={<FirstTimeBuyer />} />
            <Route path="/remortgage-guide" element={<Remortgage />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/cookies" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/survey-quote" element={<SurveyQuote />} />
            <Route path="/survey-reward-terms" element={<RewardTerms />} />
            <Route path="/reward-terms" element={<RewardTerms />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/conveyancing-quote" element={<ConveyancingQuote />} />
            <Route path="/stamp-duty-calculator" element={<StampDuty />} />
            <Route path="/about" element={<About />} />
            <Route path="/editorial-standards" element={<EditorialStandards />} />
            <Route path="/cashback" element={cashbackPromotionEnabled ? <Cashback /> : <CashbackUnavailable />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
